const translation = {
  errorBoundary: {
    title: 'Qualcosa è andato storto',
    description: 'Impossibile visualizzare questa pagina. I tuoi dati non sono stati modificati. Riprova o ricarica la pagina.',
    offlineTitle: 'Non riusciamo a raggiungere la piattaforma',
    offlineDescription: 'La connessione alla piattaforma non è riuscita. Controlla la connessione a internet e riprova.',
    retry: 'Riprova',
    reload: 'Ricarica la pagina',
  },
  notifications: {
    empty: 'Nessuna nuova notifica',
    clearAll: 'Cancella tutto',
    clearAllConfirm: 'Cancellare tutte le notifiche? Questa azione non può essere annullata.',
    clearAllFailed: 'Impossibile cancellare le notifiche',
    markReadFailed: 'Impossibile segnare la notifica come letta',
    delete: 'Elimina notifica',
    deleteFailed: 'Impossibile eliminare la notifica',
    reminderTitle: 'Misurazione in scadenza',
    reminderBody: 'È quasi ora di registrare {{measurement}} per {{programme}}.',
    cleared: 'Notifiche cancellate',
    deleted: 'Notifica eliminata',
  },
  dataGrid: {
    noResultsFound: 'Nessun risultato trovato',
    selectAll: 'Seleziona tutto',
    selectRow: 'Seleziona {{name}}',
    rowLabel: 'riga {{id}}',
    ascending: 'Crescente',
    descending: 'Decrescente',
    sortByColumn: 'Ordina per {{column}} ({{direction}})',
  },
  manageUsers: {
    title: 'Membri dell\'organizzazione',
    subtitle: 'Le persone della tua organizzazione e cosa sono qui.',
    nameColumn: 'Nome',
    emailColumn: 'E-mail',
    rolesColumn: 'Ruoli',
    rolesPlaceholder: 'Aggiungi un ruolo',
    rolesSaved: 'Ruoli aggiornati',
    rolesFailed: 'Non è stato possibile aggiornare i ruoli',
    filterLabel: 'Ruolo',
    filterAll: 'Tutti i ruoli',
    filterNone: 'Senza ruolo',
    noTenantNotice: 'Le persone sono elencate per organizzazione, e questo account non appartiene a nessuna.',
    noTenantTitle: 'Ancora nessuna organizzazione',
  },
      navGroups: {
        general: 'Generale',
        programmes: 'Programmi',
        mySettings: 'Impostazioni',
      },
      navigation: {
    ownEnvironment: 'Il mio ambiente',
    platformEnvironment: 'Amministrazione della piattaforma',
    switchEnvironment: 'Cambia ambiente',
    manageUsers: 'Membri dell\'organizzazione',
        dashboard: 'La Mia Dashboard',
        foodTracking: 'Tracciamento Alimentare',
        activity: 'Attività',
        sleep: 'Sonno',
        weightBmi: 'Peso/BMI',
        wellnessValues: 'Valori di Benessere',
        progress: 'Progresso',
        insights: 'Insights',
        myCommunity: 'La Mia Comunità',
        coaches: 'Coach',
        coaching: 'Coaching',
        myProgrammes: 'I Miei Programmi',
        programs: 'Programmi',
        researchData: 'Dati di Ricerca',
        education: 'Educazione',
        analytics: 'Analitiche',
        billing: 'Fatturazione',
        shareData: 'Condividi Dati',
        settings: 'Lingua e regione',
        profile: 'Il Mio Profilo',
        logout: 'Disconnetti',
        masterData: 'Dati Principali',
        metabolicMeasurements: 'Le Mie Misurazioni',
        weeklyData: 'Dati Settimanali',
        tenantSettings: 'Impostazioni Tenant',
        dataManagement: 'Impostazioni Dati',
        manageProgrammes: 'Impostazioni Programmi',
        manageProgrammeMeasurements: 'Dati Programmi',
        manageRoles: 'Ruoli',
        dataPermissions: 'Autorizzazioni dati',
        dataProviders: 'Fonti di dati',
        adminDataProviders: 'Tutti i server FHIR',
        uploadPDF: 'Carica PDF',
        savedDocuments: 'I Miei Documenti',
        pinSidebar: 'Blocca barra laterale',
        unpinSidebar: 'Sblocca barra laterale',
      },
      devLogin: {
        subtitle: 'Sviluppo locale — autenticazione aggirata',
        roles: {
          globalAdmin: 'Admin globale',
          tenantAdmin: 'Admin del tenant',
          coach: 'Coach',
          member: 'Membro',
          remoteMember: 'Membro remoto',
        },
      },
      brand: {
        loading: 'Caricamento',
      },
      auth: {
        platformName: 'My Lifestyle Platform',
        poweredBy: 'realizzato da Stichting Je Leefstijl Als Medicijn',
        platformLogin: 'Accesso alla Piattaforma',
        password: 'Password',
        signIn: 'Accedi',
        signUp: 'Registrati',
        forgotPassword: 'Password dimenticata?',
        requestAccess: 'Richiedi accesso',
        demoMode: 'Modalità Demo - Usa qualsiasi credenziale',
        demoDescription: 'Accedi al tuo dashboard completo di benessere lifestyle',
        loginSuccess: 'Accesso riuscito! Reindirizzamento...',
        sessionExpired: {
          title: 'La sua sessione è scaduta',
          message: 'Per proteggere i suoi dati è stato disconnesso automaticamente. Acceda di nuovo per continuare.',
          signIn: 'Accedi di nuovo',
          dismiss: 'Più tardi',
        },
      },
      dashboard: {
        refreshData: 'Aggiorna dati',
        lastSynced: 'Ultima sincronizzazione {{time}}',
        justSynced: 'Appena sincronizzato',
        signInRequired: 'Devi essere connesso per visualizzare il dashboard.',
        unableToLoad: 'Impossibile caricare i dati del dashboard.',
        activeProgrammes: 'Programmi Attivi',
        programmes: 'Programmi',
        trackedMeasurements: 'Misurazioni tracciate',
        targetsConfigured: 'Obiettivi configurati',
        dateAxisLabel: 'Data',
        measurementTrends: 'Tendenze di misurazione',
        measurementTrendsSubtitle: 'Vista impilata per esplorare tutte le misurazioni insieme.',
        timeRange: 'Intervallo di tempo:',
        oneYear: '1 anno',
        days: '{{count}}g',
        noMeasurementData: 'Nessun dato di misurazione ancora',
        noMeasurementDataSubtitle: 'Quando arriveranno nuovi punti dati, la cronologia si aggiornerà automaticamente.',
        programmeTargets: 'Obiettivi del programma',
        programmeTargetsSubtitle: 'Gli obiettivi sono impostati dall\'amministratore del programma e visualizzati qui come riferimento.',
        noProgrammeMeasurements: 'Nessuna misurazione del programma disponibile ancora.',
        latestValue: 'Ultimo valore',
        targetRange: 'Intervallo obiettivo',
        noMeasurementRecorded: 'Nessuna misurazione registrata ancora',
        onTarget: 'In linea',
        needsAttention: 'Richiede attenzione',
        noTargetSet: 'Nessun obiettivo impostato',
        min: 'Min: {{value}} {{unit}}',
        max: 'Max: {{value}} {{unit}}',
        rangeTarget: '{{min}} - {{max}} {{unit}}',
        scopeFrom: 'Mostra le misurazioni da',
        scopeTo: 'Mostra le misurazioni fino a e incluso',
        saved: 'La disposizione è stata salvata.',
        settingsSaved: '{{name}} è stato salvato.',
        deleted: '{{name}} è stato eliminato.',
      },
      profile: {
        welcomeNewUser: 'Benvenuto! Completa il tuo profilo',
        newUserMessage: 'Aiutaci a personalizzare la tua esperienza compilando i tuoi dati qui sotto.',
        continueToDashboard: 'Continua alla Dashboard',
        myProfile: 'Il Mio Profilo',
        reviewDetails: 'Rivedi e aggiorna i tuoi dati personali',
        completeProfile: 'Completa il tuo profilo',
        keepUpdated: 'Mantieni le tue informazioni aggiornate per migliori approfondimenti personalizzati',
        accountInformation: 'Informazioni Account',
        referenceCode: 'Codice di Riferimento',
        anonymousSharingId: 'Il tuo ID di condivisione anonimo',
        activeSince: 'Attivo dal',
        personalDetails: 'Dettagli Personali',
        firstName: 'Nome',
        lastName: 'Cognome',
        nickname: 'Soprannome',
        nicknamePlaceholder: 'Come vorresti essere chiamato?',
        birthDate: 'Data di nascita',
        gender: 'Genere',
        genderMale: 'Maschio',
        genderFemale: 'Femmina',
        genderPrefernottosay: 'Preferisco non dirlo',
        emailAddress: 'Indirizzo E-mail',
        emailPlaceholder: 'tua.email@esempio.it',
        emailHelper: 'Indirizzo e-mail per aggiornamenti e notifiche',
        aboutMe: 'Su di Me',
        headline: 'Titolo',
        headlinePlaceholder: 'Un breve slogan su di te',
        bio: 'Biografia',
        bioPlaceholder: 'Raccontaci qualcosa di te',
        motivation: 'Motivazione',
        motivationPlaceholder: 'Cosa ti motiva ad usare questa piattaforma?',
        privacyDataSharing: 'Privacy e Condivisione Dati',
        sharingPreference: 'Preferenza di Condivisione',
        sharingHelper: 'Scegli come vuoi condividere i tuoi dati su questa piattaforma',
        shareAnonymously: 'Condividi i miei dati in modo anonimo',
        shareWithName: 'Condividi i miei dati con il mio nome',
        doNotShare: 'Non condividere i miei dati',
        notificationPreferences: 'Preferenze di Notifica',
        pushNotifications: 'Notifiche push',
        pushNotificationsDesc: 'Ricevi notifiche push sul tuo dispositivo',
        emailNotifications: 'Notifiche via e-mail',
        emailNotificationsDesc: 'Ricevi notifiche via e-mail',
        inAppNotifications: 'Notifiche in-app',
        inAppNotificationsDesc: 'Ricevi notifiche all\'interno dell\'applicazione',
        programmeNotifications: 'Notifiche di programma',
        programmeNotificationsHelper: 'Scegli, per ogni programma, quanti minuti prima di una misurazione programmata desideri essere avvisato. Disattiva le notifiche di un programma per interromperne completamente i promemoria.',
        reminderTime: 'Orario del promemoria',
        reminderTimeCustomLabel: 'Minuti (1-180)',
        reminderNoScheduledMeasurements: 'Questo programma non ha ancora misurazioni programmate.',
        notificationsLabel: 'Notifiche',
        reminderLoadFailed: 'Impossibile caricare le impostazioni di promemoria',
        saving: 'Salvataggio...',
        saveProfile: 'Salva Profilo',
        saveSuccess: 'Profilo salvato con successo',
        errorLoading: 'Impossibile caricare il profilo',
        errorSaving: 'Impossibile salvare il profilo',
      },
      uploadPDF: {
        title: 'Carica documento',
        description: 'Qui puoi caricare i tuoi file PDF.',
        documentType: 'Tipo di documento',
        selectDocumentType: 'Seleziona tipo di documento',
        labTest: 'Esame di laboratorio',
        insuranceDocument: 'Documento assicurativo',
        idCard: 'Carta d\'identità',
        enabledAIExtraction: 'Abilitato: estrarremo osservazioni dopo il caricamento.',
        disabledAIExtraction: 'Disabilitato: memorizzeremo solo il documento.',
        descriptionTitle: 'Descrizione',
        descriptionLabel: 'Descrizione',
        descriptionPlaceholder: 'es. Esame del sangue dalla visita del medico (24/01/2026)',
        filenameTitle: 'Nome file',
        filenameLabel: 'Nome file',
        filenamePlaceholder: 'Inserisci un nome file',
        filenameRequired: 'Per favore inserisci un nome file.',
        aiExtractionTitle: 'Estrazione IA',
        aiExtractionSelectTypeHelper: 'Seleziona un tipo di documento per vedere le opzioni di estrazione IA.',
        dropFilesPrompt: 'Trascina qui i file, oppure selezionali dal tuo dispositivo',
        chooseFiles: 'Scegli file',
        deleteDocument: 'Cancella selezione',
        filesSelected: 'file selezionato',
        uploadButton: 'Carica',
        documentSuccessfullyUploaded: 'Documento caricato con successo.',
        aiExtractionNotAvailable: 'L\'estrazione IA non e disponibile per questo tipo di documento',
      },
      savedDocuments: {
        fileName: 'Nome file',
        fileType: 'Tipo di file',
        uploadedBy: 'Caricato da',
        description: 'Descrizione',
        uploadDate: 'Data di caricamento',
        status: 'Stato',
        inProgress: 'In corso',
        readyForReview: 'Pronto per la revisione',
        committed: 'Impegnato',
        inReview: 'In revisione',
        uploaded: 'Caricato',
        failed: 'Non riuscito',
        unknownStatus: 'Non riuscito',
        noStatus: 'Nessuno stato',
        noDocuments: 'Nessun documento trovato',
        yourDocuments: 'I tuoi documenti',
        viewPreviouslyUploaded: 'Visualizza i documenti caricati in precedenza',
        documents: 'Documenti',
        filter: 'Filtra',
        allTypes: 'Tutti',
        preview: 'Anteprima',
        uploadNewDocument: 'Carica un nuovo documento',
        review: 'Rivedi',
        delete: 'Elimina',
        updateDocument: 'Aggiorna documento',
        update: 'Aggiorna',
        cancel: 'Annulla',
        save: 'Salva',
        documentSuccessfullyDeleted: 'Documento eliminato con successo',
        deleteError: 'Errore durante l\'eliminazione del documento',
        deleteErrorPartial_one: '{{count}} documento non è stato eliminato',
        deleteErrorPartial_other: '{{count}} documenti non sono stati eliminati',
        downloadError: 'Impossibile scaricare il documento',
        deleteConfirm: 'Sei sicuro di voler eliminare {{count}} documento/i?',
        deleting: 'Eliminazione...',
        close: 'Chiudi',
        download: 'Scarica',
        types: {
          bloodTestReport: 'Referto esame del sangue',
          stoolTestReport: 'Referto esame delle feci',
          consultationNote: 'Nota di consulto',
        },
        updateSuccess: 'Documento aggiornato',
        updateError: 'Impossibile aggiornare il documento',
      },
      documentExtractionReview: {
        aiChip: 'TRPI con IA',
        title: 'Revisione estrazione',
        previewTitle: 'Anteprima documento',
        preview: {
          loadingDocument: 'Caricamento documento...',
          preparingPdf: 'Preparazione PDF...',
          zoom: 'Zoom {{percent}}%',
          zoomControlsAria: 'Controlli zoom',
          zoomOut: 'Riduci',
          fit: 'Adatta',
          zoomIn: 'Ingrandisci',
          fullscreen: 'Schermo intero',
          exitFullscreen: 'Esci da schermo intero',
          unavailable: 'L\'anteprima in-app non è disponibile per questo file. Scarica questo file per visualizzarlo.',
          pageOf: 'Pagina {{current}} di {{total}}',
          prevPageAria: 'Pagina precedente',
          nextPageAria: 'Pagina successiva',
        },
        subtitle: 'Rivedi i valori estratti prima di confermarli nelle tue osservazioni principali.',
        committedInfo: 'Questo documento non può essere modificato ulteriormente, ma puoi comunque ispezionare i valori estratti.',
        commit: {
          action: 'Conferma nel core',
          committed: 'Confermato',
          aria: 'Conferma le misurazioni estratte',
          success: 'Documento confermato',
          error: 'Impossibile confermare il documento',
        },
        tooltips: {
          download: 'Scarica',
          fullscreen: 'Schermo intero',
          exitFullscreen: 'Esci da schermo intero',
        },
        aria: {
          download: 'Scarica documento',
          fullscreen: 'Alterna schermo intero del pannello destro',
        },
        updatedAt: 'Aggiornato il: {{date}}',
        failedMessage: 'Estrazione non riuscita. Puoi comunque visualizzare l\'anteprima del documento. Contatta il supporto se il problema persiste.',
        loadDataError: 'Errore durante il caricamento dei dati estratti. Per favore riprova.',
        extractionInProgress: 'L\'estrazione è in corso.',
        notExtracted: 'Non estratto',
        timeline: {
          button: 'Vedi cronologia',
          title: 'Cronologia estrazione',
        },
        loading: 'Caricamento estrazione...',
        providers: {
          organisation: 'organizzazione',
          practitioner: 'medico',
          searchPlaceholder: 'Cerca {{type}} esistente',
          notInList: 'Non e nella lista',
        },
        sections: {
          measurements: {
            title: 'Misurazioni estratte',
            columns: {
              measurementName: 'Misurazione estratta',
              valueExtracted: 'Valore estratto',
              unitExtracted: 'Unita (estratta)',
              ucumCode: 'Codice UCUM',
              ucumName: 'Nome UCUM',
              loincCode: 'Codice LOINC',
              loincName: 'Nome LOINC',
              referenceRangeMin: 'Ref min',
              referenceRangeMax: 'Ref max',
            },
            actions: {
              resetColumns: 'Reimposta visibilita colonne',
              edit: 'Modifica misurazioni',
              save: 'Salva misurazioni',
              cancel: 'Annulla modifiche alle misurazioni',
              deleteRow: 'Elimina riga',
              deleteRowDisabled: 'Abilita la modifica per eliminare righe',
              addRow: 'Aggiungi riga',
            },
            aria: {
              resetColumns: 'Reimposta visibilita colonne',
              edit: 'Modifica misurazioni estratte',
              save: 'Salva misurazioni estratte',
              cancel: 'Annulla modifiche alle misurazioni estratte',
              deleteRow: 'Elimina riga {{id}}',
            },
            toasts: {
              addSuccess: 'Riga di misurazione aggiunta',
              addError: 'Impossibile aggiungere la riga di misurazione',
              deleteSuccess: 'Misurazione eliminata',
              deleteError: 'Impossibile eliminare la misurazione',
            },
          },
          organisation: {
            title: 'Organizzazione esecutrice',
            status: {
              matchFound: 'Organizzazione trovata',
              noMatch: 'Nessuna corrispondenza organizzazione',
            },
            tooltips: {
              validation: 'Compila i valori corretti',
              save: 'Salva dettagli organizzazione',
              cancel: 'Annulla modifiche organizzazione',
            },
            aria: {
              edit: 'Modifica organizzazione esecutrice',
              save: 'Salva modifiche dell\'organizzazione esecutrice',
              cancel: 'Annulla modifiche dell\'organizzazione estratta',
            },
            fields: {
              name: 'Nome',
              address: 'Indirizzo',
              houseNumber: 'Numero civico',
              city: 'Citta',
              postalCode: 'CAP',
              countryCode: 'Codice paese',
              contactPerson: 'Referente',
              phoneNumber: 'Telefono',
              emailAddress: 'Email',
            },
          },
          practitioner: {
            title: 'Medico richiedente',
            status: {
              matchFound: 'Medico trovato',
              noMatch: 'Nessuna corrispondenza medico',
            },
            tooltips: {
              validation: 'Compila i valori corretti',
              save: 'Salva dettagli medico',
              cancel: 'Annulla modifiche medico',
            },
            aria: {
              edit: 'Modifica medico richiedente',
              save: 'Salva modifiche del medico richiedente',
              cancel: 'Annulla modifiche del medico estratto',
            },
            fields: {
              name: 'Nome',
              role: 'Ruolo',
              phoneNumber: 'Telefono',
              emailAddress: 'Email',
            },
          },
        },
        sectionSaved: 'Le modifiche sono state salvate.',
        sectionSaveFailed: 'Impossibile salvare le modifiche.',
      },
      content: {
        billing: {
          title: 'Fatturazione e Pagamenti',
          description: 'Gestisci abbonamenti, pagamenti e funzionalità premium per funzionalità migliorate.',
          viewBilling: 'Visualizza Fatturazione',
        },
      },
      masterData: {
        tabs: {
          measurements: 'Misurazioni',
          units: 'Unità',
        },
        measurementList: {
          subtitle: 'Tutti i codici che la piattaforma conosce: la versione di LOINC e quelli propri. Aprine uno per vedere i suoi assi e le sue unità.',
        },
        measurementCodes: {
          list: {
            columns: {
              name: 'Nome',
              code: 'Codice',
              codeSystem: 'Sistema di codici',
              status: 'Stato',
              inUse: 'In uso',
            },
            yes: 'Sì',
            no: 'No',
            views: {
              label: 'Mostra',
              all: 'Tutti i codici',
              inUse: 'In uso',
            },
            systemFilter: 'Sistema di codici',
            systemAll: 'Tutti i sistemi di codici',
          },
          general: {
            code: 'Codice',
            codeSystem: 'Sistema di codici',
            name: 'Nome',
            status: 'Stato',
            release: 'Versione',
            releaseValue: '{{version}}, caricata il {{date}}',
            releaseNone: 'Non applicabile: nessuna versione accompagna un codice della piattaforma.',
            releaseUnknown: 'Non registrata per questo codice.',
            valueKind: 'Tipo di valore',
            quantityKind: 'Tipo di grandezza',
          },
          axes: {
            title: 'Cosa misura',
            component: 'Componente',
            analyte: 'Analita',
            property: 'Proprietà',
            time: 'Tempo',
            system: 'Sistema',
            scale: 'Scala',
            method: 'Metodo',
            noMethod: 'Nessuno',
            unknown: 'La piattaforma non conosce gli assi di questo codice. Non è raggruppato con nulla.',
          },
          groups: {
            title: 'Raggruppato con',
            nothing: 'A questo livello non è raggruppato con nulla.',
          },
          levels: {
            THIS_CODE: 'Solo questo codice',
            ANY_METHOD: 'Lo stesso, qualunque sia il metodo',
          },
          trace: {
            title: 'Risali a un valore',
            help: 'Inserisci il numero che ti viene dato per un valore. Vedi come è stato registrato e da dove arriva.',
            number: 'Numero del valore',
            show: 'Mostra origine',
          },
          dialog: {
            addTitle: 'Aggiungi una misurazione della piattaforma',
            editTitle: 'Modifica {{name}}',
            name: 'Nome',
            code: 'Codice',
            codeHelp: 'Inizia con X, per esempio X-HAPPY-1. Due misurazioni non condividono lo stesso codice.',
            codeSystem: 'Sistema di codici',
            analyteHelp: 'Lascia vuoto per usare il componente.',
            noPart: 'Nessun Part corrisponde. Scrivi un nome per aggiungerne uno.',
            partsFailed: 'Non è stato possibile leggere i Part. Scrivi di nuovo per riprovare.',
            addPart: 'Aggiungi «{{name}}» come nuovo Part',
            partAdded: '{{name}} aggiunto come Part',
            newPropertyKind: 'Tipo di grandezza per una nuova proprietà',
            newPropertyKindHelp: 'Usato solo se aggiungi una nuova proprietà qui sopra.',
            noKind: 'Nessuno',
          },
        },
        dimensionWords: {
          length: 'lunghezza',
          mass: 'massa',
          time: 'tempo',
          amountOfSubstance: 'quantità di sostanza',
          electricCurrent: 'corrente elettrica',
          temperature: 'temperatura',
          luminousIntensity: 'intensità luminosa',
          dimensionless: 'adimensionale',
          per: 'per',
        },
        unitTabs: {
          label: 'Unità e masse molari',
          units: 'Elenco delle unità',
          molarMasses: 'Masse molari',
        },
        unitList: {
          subtitle: 'Le unità in cui si possono registrare i valori, per ogni organizzazione, con la loro dimensione. Quali misurazioni ne usano una si imposta su ciascuna misurazione.',
          noUcum: 'Nessun codice UCUM',
          noDimension: 'Nessuna dimensione',
          columns: {
            quantityKinds: 'Grandezze',
          },
        },
        unitDialog: {
          dimensionHelp: 'Per un\'unità senza codice UCUM la dimensione si inserisce qui. Le unità della stessa dimensione si possono convertire tra loro.',
          noDimension: 'Nessuna dimensione',
          ucumHelp: 'Un codice della versione UCUM che la piattaforma possiede, come kg. Due unità non condividono lo stesso codice.',
          noUcum: 'Questa unità non ha un codice UCUM. Aggiungine uno se ce l\'ha, come kg.',
          workedOut: 'Ricavato dal codice UCUM.',
          workedOutAfterSave: 'Ricavato al salvataggio.',
          quantityKinds: 'Grandezze che può esprimere',
          quantityKindsHelp: 'Un\'unità si adatta a una misurazione se può esprimere la grandezza che questa indica. Presa da QUDT o scelta qui.',
          dimensionsFailed: 'Non è stato possibile leggere le dimensioni, quindi non se ne può scegliere nessuna.',
          dimensionsRetry: 'Riprova',
        },
        measurementUnits: {
          add: 'Collega un\'unità',
          edit: 'Modifica collegamento',
          remove: 'Rimuovi collegamento',
          isDefault: 'Canonica',
          columns: {
            isDefault: 'Canonica',
            conversion: 'Conversione nell\'unità canonica',
            approvedBy: 'Approvato da',
            validMinimum: 'Valido da',
            validMaximum: 'Valido fino a',
          },
          confirm: 'Conferma il fattore',
          confirmedToast: 'Fattore di {{unit}} confermato',
          factor: '1 {{from}} = {{multiplier}} {{to}}',
          factorWithOffset: '({{from}} + {{offset}}) × {{multiplier}} = {{to}}',
          viaAlgebra: 'Ricavato dai codici UCUM.',
          viaMolarMass: 'Tramite la massa molare di {{analyte}}, {{mass}} g/mol. Fonte: {{source}}.',
          formula: '{{factor}}. {{via}}',
          approved: '{{by}}, {{date}}',
          notApproved: 'Non ancora approvato',
          unavailable: {
            dimensionDiffers: 'Nessun fattore: questa unità ha una dimensione diversa da quella canonica.',
            noCanonicalUnit: 'Ancora nessun fattore: la misura non ha un\'unità canonica.',
            noMolarMass: 'Ancora nessun fattore: la massa molare dell\'analita non è registrata.',
            noDimension: 'Nessun fattore: questa unità non ha dimensione.',
          },
          enterMolarMass: 'Inserisci la massa molare',
          removeDialog: {
            title: 'Rimuovere questo collegamento?',
          },
        },
        unitLinkDialog: {
          isDefault: 'Unità canonica: i valori sono mostrati in essa e il suo intervallo è verificato',
          isDefaultHelp: 'La prima unità di una misurazione è la sua unità canonica. Ce n\'è una sola.',
          otherDefault: 'Un\'altra unità è quella canonica. Disattivala prima lì.',
          validMinimum: 'Minimo valido',
          validMaximum: 'Massimo valido',
          validHelp: 'Facoltativo. Il valore più basso registrabile, in {{unit}}. Un valore in un\'altra unità viene prima convertito.',
          rangeWrong: 'Il minimo è maggiore del massimo.',
        },
        molarMasses: {
          title: 'Masse molari',
          subtitle: 'Una concentrazione di massa incontra una concentrazione molare dello stesso analita tramite la sua massa molare. Ogni massa ha la sua fonte.',
          add: 'Aggiungi massa molare',
          edit: 'Modifica massa molare',
          remove: 'Rimuovi massa molare',
          addTitle: 'Aggiungi una massa molare',
          editTitle: 'Modifica la massa molare di {{name}}',
          columns: {
            analyte: 'Analita',
            gramsPerMole: 'Grammi per mole',
            source: 'Fonte',
          },
          analyte: 'Analita',
          analyteHelp: 'Cerca per nome o numero di Part, come Glucosio.',
          gramsPerMole: 'Grammi per mole',
          massHelp: 'Per il glucosio: 180.156.',
          massWrong: 'Inserisci un numero maggiore di 0, con fino a dieci cifre prima e dopo il punto.',
          source: 'Fonte',
          sourceHelp: 'Da dove viene il numero: un gruppo LOINC, un identificatore ChEBI o PubChem, un\'opera di riferimento.',
          removeDialog: {
            title: 'Rimuovere questa massa molare?',
            message: '{{name}} non ha più una massa molare. I fattori che la usano non si possono più ricavare.',
          },
        },
      },
      tenantSettings: {
        title: 'Impostazioni Tenant',
        subtitle: 'Gestisci impostazioni',
        loadError: 'Impossibile caricare le impostazioni del tenant. Potresti non avere il permesso di visualizzare questo tenant.',
        generalInfo: 'Informazioni Generali',
        tenantName: 'Nome Tenant',
        organisation: 'Organizzazione',
        organisationHelper: 'L\'organizzazione non può essere modificata',
        tenantId: 'ID Tenant',
        yourRole: 'Il Tuo Ruolo',
        roleDescription: 'Il tuo ruolo in questa organizzazione è {{role}}.',
        permissionsConfigured: 'Cosa può fare questo ruolo lo configura l\'organizzazione stessa. Un amministratore può vederlo e modificarlo nella schermata dei ruoli.',
        saveName: 'Salva nome',
        nameSaved: 'Il nome del tenant è stato aggiornato.',
        saveError: 'Non è stato possibile salvare il nome. Potresti non avere il permesso di modificarlo.',
      },
      communityUsers: {
        title: 'Utenti della comunità',
        subtitle: 'Tutti gli utenti che hanno un account sulla piattaforma. I dettagli personali vengono mostrati solo in base alle preferenze di privacy di ogni utente.',
        loadError: 'Impossibile caricare gli utenti della comunità. Riprova.',
        view: 'Visualizza',
        noUsersTitle: 'Nessun utente condiviso',
        noUsersNotice: 'Nessuno ha ancora reso disponibili i propri dati per la visualizzazione.',
      },
      adminDashboard: {
        menuItems: {
          questionnaires: 'Questionari',
          tenants: 'Tenant',
          organisations: 'Organizzazioni',
          users: 'Utenti di sistema',
        },
        users: {
          title: 'Utenti di sistema',
          comingSoon: 'La gestione utenti sarà disponibile presto...',
        },
      },
      organisationDialog: {
        titleCreate: 'Crea Nuova Organizzazione',
        titleEdit: 'Modifica organizzazione',
        emailInvalid: 'Inserisci un indirizzo email come nome@esempio.it',
        dateInvalid: 'Inserisci una data',
        legalNameRequired: 'Il nome legale è obbligatorio',
        createError: 'Impossibile creare l\'organizzazione. Verificare se i campi univoci sono già in uso.',
        fields: {
          legalName: 'Nome Legale',
          tradeName: 'Nome Commerciale',
          taxId: 'Codice Fiscale',
          referenceCode: 'Codice di Riferimento',
          emailAddress: 'Indirizzo Email',
          phoneNumber: 'Numero di Telefono',
          website: 'Sito Web',
          practiceCode: 'Codice Pratica',
          chamberOfCommerceNumber: 'Numero Camera di Commercio',
          subscriptionDate: 'Data di Sottoscrizione',
          active: 'Attivo',
        },
        actions: {
          create: 'Crea',
        },
      },
      organisationList: {
        title: 'Organizzazioni',
        addButton: 'Aggiungi organizzazione',
        updateSuccess: 'Organizzazione aggiornata con successo',
        updateError: 'Impossibile aggiornare l\'organizzazione',
        columns: {
          legalName: 'Ragione sociale',
          tradeName: 'Nome commerciale',
          taxId: 'Partita IVA',
          referenceCode: 'Codice di riferimento',
          emailAddress: 'Email',
          phoneNumber: 'Telefono',
          website: 'Sito web',
          practiceCode: 'Codice pratica',
          chamberOfCommerceNumber: 'Numero camera di commercio',
          subscriptionDate: 'Data di sottoscrizione',
          status: 'Stato',
        },
        statusLabels: {
          active: 'Attivo',
          inactive: 'Inattivo',
        },
        edit: 'Modifica',
        deactivate: 'Disattiva',
        alreadyInactive: 'Già inattiva. Riattivala con Modifica.',
        deactivateTitle: 'Disattiva organizzazione',
        deactivateMessage: '{{name}} sarà segnata come inattiva. Non viene rimosso nulla e puoi riattivarla con Modifica.',
        deactivated: 'Organizzazione disattivata',
        created: 'Organizzazione creata',
      },
      questionnaireEditor: {
        questionsCount: 'Domande ({{count}})',
        addQuestionButton: 'Aggiungi domanda',
        emptyState: {
          message: 'Ancora nessuna domanda. Aggiungi la tua prima domanda!',
          button: 'Aggiungi domanda',
        },
        question: {
          prefix: 'Domanda',
          required: 'Obbligatorio',
          identity: 'Identità: ',
          optionsLabel: 'Opzioni:',
        },
        tooltips: {
          edit: 'Modifica',
          delete: 'Elimina',
        },
        dialog: {
          titleNew: 'Nuova domanda',
          titleEdit: 'Modifica domanda',
          questionType: 'Tipo di domanda',
          questionPrompt: 'Testo della domanda',
          requiredQuestion: 'Domanda obbligatoria',
          identityField: 'Questo è un campo di identità (per l\'onboarding degli utenti)',
          identityFieldType: 'Tipo di campo di identità',
          listOptionsTitle: 'Opzioni elenco',
          addOptionButton: 'Aggiungi opzione',
          codeLabel: 'Codice',
          codePlaceholder: 'es., SAT_ALTO',
          valueLabel: 'Valore visualizzato',
          valuePlaceholder: 'es., Molto soddisfatto',
          emptyOptions: 'Aggiungi almeno un\'opzione per le domande a tendina',
          cancel: 'Annulla',
          save: 'Salva',
          create: 'Crea',
          removeOption: 'Rimuovi opzione',
        },
        deleteDialog: {
          title: 'Elimina domanda',
          message: 'Sei sicuro di voler eliminare questa domanda? Questo eliminerà anche tutte le risposte associate.',
          cancel: 'Annulla',
          delete: 'Elimina',
        },
        messages: {
          updateSuccess: 'Domanda aggiornata con successo',
          createSuccess: 'Domanda creata con successo',
          deleteSuccess: 'Domanda eliminata con successo',
          saveError: 'Impossibile salvare la domanda',
          deleteError: 'Impossibile eliminare la domanda',
        },
        questionTypes: {
          text: 'Testo',
          number: 'Numero',
          date: 'Data',
          list: 'Elenco/Menu a tendina',
          boolean: 'Sì/No',
        },
        identityTypes: {
          first_name: 'Nome',
          last_name: 'Cognome',
          email: 'Email',
          date_of_birth: 'Data di nascita',
        },
      },
      questionnaireList: {
        title: 'Questionari',
        newButton: 'Aggiungi questionario',
        table: {
          name: 'Nome',
          description: 'Descrizione',
          status: 'Stato',
          version: 'Versione',
          publicLink: 'Link pubblico',
        },
        statusLabels: {
          active: 'Attivo',
          inactive: 'Inattivo',
        },
        dialog: {
          titleNew: 'Aggiungi questionario',
          titleEdit: 'Modifica questionario',
          name: 'Nome',
          description: 'Descrizione',
          active: 'Attivo',
          create: 'Crea',
          nameRequired: 'Inserisci un nome',
          publicLink: 'Link pubblico',
          noPublicLink: 'Questo questionario non ha ancora un link pubblico.',
          newLink: 'Crea un nuovo link al salvataggio. Il link attuale smetterà di funzionare.',
          makeLink: 'Crea un link pubblico al salvataggio',
        },
        deleteDialog: {
          title: 'Rimuovi questionario',
          message: '{{name}} e le sue domande saranno rimossi. Un questionario a cui le persone hanno risposto non viene rimosso; disattivalo invece.',
          delete: 'Rimuovi',
        },
        messages: {
          updateSuccess: 'Questionario aggiornato con successo',
          createSuccess: 'Questionario creato con successo',
          deleteSuccess: 'Questionario rimosso',
          saveError: 'Impossibile salvare il questionario',
          linkCopied: 'Link copiato negli appunti',
          copyFailed: 'Non è stato possibile copiare il link',
        },
        copyLink: 'Copia link',
        copyLinkOf: 'Copia il link pubblico di {{name}}',
        noLink: 'Nessuno',
        edit: 'Modifica',
        delete: 'Rimuovi',
        noOrganisationTitle: 'Nessuna organizzazione',
        noOrganisationNotice: 'I questionari appartengono a un’organizzazione, e questo account non appartiene a nessuna.',
      },
      submissionViewer: {
        table: {
          id: 'ID',
          status: 'Stato',
          email: 'Email',
          name: 'Nome',
          submittedAt: 'Inviato il',
        },
        statusLabels: {
          submitted: 'Inviato',
          draft: 'Bozza',
          scored: 'Valutato',
          abandoned: 'Abbandonato',
        },
        dialog: {
          title: 'Invio - Risposte',
          submissionDetails: 'Dettagli invio',
          status: 'Stato',
          submittedAt: 'Inviato il',
          notYetSubmitted: 'Non ancora inviato',
          email: 'Email',
          name: 'Nome',
          answersCount: 'Risposte ({{count}})',
          noAnswers: 'Nessuna risposta inviata.',
          questionPrefix: 'Domanda {{number}}',
          close: 'Chiudi',
          unknownQuestion: 'Una domanda che non è più in questo questionario',
        },
        booleanValues: {
          yes: 'Sì',
          no: 'No',
        },
        answersFailed: 'Non è stato possibile caricare le risposte',
        openAnswers: 'Risposte inviate il {{sent}}',
      },
      tenantList: {
        title: 'Tenant',
        addButton: 'Aggiungi Tenant',
        saveError: 'Impossibile salvare il tenant',
        noOrganisationsWarning: 'Nessuna organizzazione disponibile. Crea prima un\'organizzazione prima di aggiungere tenant.',
        table: {
          id: 'ID',
          name: 'Nome',
          organisation: 'Organizzazione',
        },
        tooltips: {
          edit: 'Modifica',
        },
        dialog: {
          titleCreate: 'Crea Tenant',
          titleEdit: 'Modifica Tenant',
          tenantName: 'Nome Tenant',
          organisation: 'Organizzazione',
          create: 'Crea',
          nameRequired: 'Inserisci un nome',
          organisationRequired: 'Scegli un’organizzazione',
          organisationLocked: 'Un tenant resta con la sua organizzazione',
        },
        messages: {
          created: 'Tenant aggiunto',
          updated: 'Tenant salvato',
        },
      },
      publicQuestionnairePage: {
        loading: 'Caricamento...',
        invalidLink: 'Link questionario non valido',
        notFound: 'Questionario non trovato o non più attivo',
        checkLink: 'Si prega di verificare il link e riprovare.',
        thankYou: 'Grazie!',
        submitted: 'Le tue risposte sono state inviate con successo.',
        newAccountCreated: 'È stato creato un nuovo account per te. Controlla la tua email per le istruzioni di accesso.',
        progress: 'Progresso',
        questions: 'domande',
        required: 'Questo campo è obbligatorio',
        identityFieldInfo: 'Queste informazioni saranno utilizzate per creare il tuo account',
        submitButton: 'Invia Questionario',
        submitting: 'Invio in corso...',
        autoSave: 'Le tue risposte vengono salvate automaticamente mentre scrivi',
        missingRequired: 'Si prega di rispondere a tutte le domande obbligatorie ({{count}} rimanenti)',
        submitError: 'Invio del questionario non riuscito. Si prega di riprovare.',
        placeholders: {
          text: 'Inserisci la tua risposta...',
          number: 'Inserisci un numero...',
          email: 'Inserisci la tua email',
          firstName: 'Inserisci il tuo nome',
          lastName: 'Inserisci il tuo cognome',
          dateOfBirth: 'Inserisci la tua data di nascita',
        },
        booleanValues: {
          yes: 'Sì',
          no: 'No',
        },
        answerSaveFailed: 'Impossibile salvare la risposta. Riprova.',
      },
      manageProgrammeMeasurements: {
        title: 'Misurazioni del Programma',
        tenant: 'Tenant',
        addButton: 'Aggiungi Misurazione del Programma',
        noProgrammes: 'Nessun programma disponibile. Si prega di creare prima un programma.',
        noOrganisationTitle:
          'Ancora nessuna organizzazione',
        noOrganisation: 'Le misurazioni del programma appartengono a un’organizzazione, e questo account non appartiene a nessuna.',
        rolesUnknownTitle: 'I tuoi ruoli non sono leggibili',
        rolesUnknownNotice:
          'Senza di essi questa schermata non sa quale organizzazione mostrare, che non è lo stesso di non appartenere a nessuna.',
        table: {
          programmeName: 'Nome del Programma',
          measurementName: 'Nome della Misurazione',
          loincCode: 'Codice LOINC',
          minimumTarget: 'Obiettivo Minimo',
          maximumTarget: 'Obiettivo Massimo',
          defaultUnit: 'Unità Predefinita',
          reminder: 'Promemoria',
          everyWeeks: 'Ogni {{count}} settimane: {{days}}',
        },
        actions: {
          edit: 'Modifica',
          delete: 'Elimina',
        },
        dialog: {
          titleAdd: 'Aggiungi Misurazione del Programma',
          titleEdit: 'Modifica Misurazione del Programma',
          programme: 'Programma',
          measurement: 'Misurazione',
          minimumTarget: 'Obiettivo Minimo',
          maximumTarget: 'Obiettivo Massimo',
          defaultUnit: 'Unità Predefinita',
          selectProgramme: 'Seleziona un programma',
          selectMeasurement: 'Seleziona una misurazione',
          measurementSearchHint: 'Scrivi almeno tre lettere del nome o del codice.',
          measurementNoMatch: 'Nessuna misurazione corrisponde.',
          measurementSearchFailed: 'Non è stato possibile leggere le misurazioni. Scrivi di nuovo per riprovare.',
          selectUnit: 'Seleziona un\'unità',
          repeatEvery: 'Ripeti ogni',
          weeks: 'settimane',
          repeatOn: 'Ripeti il',
          ends: 'Termina',
          endsProgrammeEnd: 'Quando termina il programma',
          endsOn: 'Il',
          endsAfter: 'Dopo',
          occurrences: 'occorrenze',
          timeOfDay: 'Alle',
          timeOfDayOptional: 'facoltativo',
          selectWeekdaysFirstWarning: 'Seleziona prima un giorno della settimana',
          recurrenceHint: 'Non selezionare alcun giorno per non registrare alcuna pianificazione. Le settimane sono contate dalla settimana di inizio del programma.',
          programmeHasNoEndDate: 'Questo programma non ha una data di fine, quindi si ripete indefinitamente',
          save: 'Salva',
          update: 'Aggiorna',
        },
        deleteConfirm: 'Sei sicuro di voler eliminare la misurazione "{{measurementName}}" dal programma "{{programmeName}}"?',
        deleteTitle: 'Rimuovere questa misurazione dal programma?',
        messages: {
          loadRolesFailed: 'Caricamento dei ruoli tenant non riuscito',
          loadDataFailed: 'Caricamento dei dati non riuscito',
          partlyRead: 'Non è stato possibile leggere le misurazioni di alcuni programmi, quindi questo elenco potrebbe essere incompleto.',
          noTenantSelected: 'Nessun tenant selezionato',
          selectProgrammeError: 'Si prega di selezionare un programma',
          selectMeasurementError: 'Si prega di selezionare una misurazione',
          selectUnitError: 'Si prega di selezionare un\'unità predefinita',
          recurrenceIntervalError: 'Ripeti ogni deve essere un numero intero di settimane tra 1 e 52',
          recurrenceEndDateError: 'Scegli una data di fine non anteriore all\'inizio del programma',
          recurrenceOccurrencesError: 'Il numero di occorrenze deve essere un numero intero tra 1 e 520',
          deleteSuccess: 'Misurazione del programma eliminata con successo',
          addSuccess: 'Misurazione del programma aggiunta con successo',
          addFailed: 'Aggiunta della misurazione del programma non riuscita',
          updateSuccess: 'Misurazione del programma aggiornata con successo',
          updateFailed: 'Aggiornamento della misurazione del programma non riuscito',
          notAllowed: 'Non puoi modificarlo.',
        },
      },
      manageProgrammeDialog: {
        titleCreate: 'Crea Nuovo Programma',
        titleEdit: 'Modifica Programma',
        programmeName: 'Nome del Programma',
        programmeNameRequired: 'Il nome del programma è obbligatorio',
        description: 'Descrizione',
        targetAudience: 'Pubblico Target',
        startDate: 'Data di Inizio',
        startDateRequired: 'La data di inizio è obbligatoria',
        startDateLocked:
          'La data di inizio non può essere modificata dopo la creazione',
        endDate: 'Data di Fine',
        endDateHelper: 'Lasciare vuoto per programmi in corso',
        endDateError: 'La data di fine deve essere successiva alla data di inizio',
        startDatePast: 'La data di inizio non può essere nel passato',
        endDatePast: 'La data di fine non può essere nel passato',
        saveChanges: 'Salva Modifiche',
        createProgramme: 'Crea Programma',
        saveFailed: 'Salvataggio del programma non riuscito',
        banner: {
          label: 'Banner',
          choose: 'Scegli un’immagine',
          remove: 'Rimuovi banner',
          none: 'Nessun banner ancora. I membri vedono il nome del programma sul colore del tenant.',
          accepted: 'PNG, WebP o JPEG, al massimo 2 MB, tra 800 × 200 e 6000 × 6000 pixel.',
          refused: 'Questo file non può essere usato. Scegli un’immagine PNG, WebP o JPEG di al massimo 2 MB e tra 800 × 200 e 6000 × 6000 pixel.',
          saveFailed: 'Non è stato possibile salvare il banner. Riprova.',
        },
      },
      manageProgrammes: {
        title: 'Programmi',
        addButton: 'Aggiungi Programma',
        tenant: 'Tenant',
        loadRolesFailed: 'Caricamento dei ruoli tenant non riuscito',
        loadProgrammesFailed: 'Caricamento dei programmi non riuscito',
        table: {
          programmeName: 'Nome del programma',
          description: 'Descrizione',
          target: 'Obiettivo',
          startDate: 'Data di inizio',
          endDate: 'Data di fine',
        },
        actions: {
          edit: 'Modifica',
          delete: 'Elimina',
        },
        deleteDialog: {
          title: 'Elimina Programma',
          message: 'Sei sicuro di voler eliminare il programma "{{programmeName}}"? Questa azione non può essere annullata.',
          delete: 'Elimina',
        },
        messages: {
          createSuccess: 'Programma creato con successo',
          updateSuccess: 'Programma aggiornato con successo',
          deleteSuccess: 'Programma eliminato con successo',
        },
        ongoing: 'In corso',
        loadFailedTitle: 'Programmi non leggibili',
        noOrganisationNotice: 'I programmi appartengono a un’organizzazione, e questo account non appartiene a nessuna.',
        noOrganisationTitle: 'Ancora nessuna organizzazione',
        rolesUnknownNotice: 'Senza di essi questa schermata non sa cosa amministri, che non è lo stesso di non amministrare nulla.',
        rolesUnknownTitle: 'I tuoi ruoli non sono leggibili',
      },
      programmesOverview: {
        title: 'Programmi Disponibili',
        loadFailed: 'Caricamento dei programmi non riuscito',
        enrollFailed: 'Iscrizione al programma non riuscita',
        enroll: 'Iscriviti',
        unenroll: 'Annulla iscrizione',
        unenrollFailed: 'Annullamento iscrizione al programma non riuscito',
        preview: 'Anteprima',
        table: {
          programmeName: 'Nome del Programma',
          target: 'Obiettivo',
          programmeStartDate: 'Data di Inizio del Programma',
          programmeEndDate: 'Data di Fine del Programma',
          enrollmentStatus: 'Stato Iscrizione',
        },
        status: {
          notEnrolled: 'Non Iscritto',
          active: 'Attivo',
          inactive: 'Inattivo',
        },
        previewPanel: {
          enrolledFrom: 'Sei iscritto a questo programma dal:',
          ongoing: 'Oggi',
        },
        noProgrammesNotice: 'La tua organizzazione non ha ancora aperto programmi a cui iscriversi.',
        noProgrammesTitle: 'Ancora nessun programma',
        programmesUnknownNotice: 'L’elenco non è arrivato, che non è lo stesso di non averne.',
        programmesUnknownTitle: 'Programmi non leggibili',
        retry: 'Riprova',
        close: 'Chiudi',
        confirmUnenroll: {
          title: 'Vuoi lasciare questo programma?',
          body: 'La tua iscrizione a {{programme}} verrà annullata. Potrai iscriverti di nuovo più tardi.',
          cancel: 'Annulla',
          confirm: 'Annulla iscrizione',
        },
      },
      observations: {
        addObservation: 'Aggiungi misurazione',
        viewToggleLabel: 'Vista',
        viewCalendar: 'Calendario',
        viewStack: 'Pila',
        viewTimeline: 'Cronologia',
        filter: {
          title: 'Filtra',
          label: 'Programmi',
          all: 'Tutti i programmi',
        },
        submitting: 'Invio in corso...',
        searchBy: 'Cerca per',
        searchValue: 'Valore di ricerca',
        columns: 'Colonne',
        columnsLabel: 'Cambia Colonne Visualizzate',
        eventType: 'Tipo di evento',
        dateTime: 'Data ora',
        measurementType: 'Tipo di misurazione',
        value: 'Valore',
        sourceDocument: 'Documento di origine',
        sourceDocumentDescription: 'Descrizione del documento',
        actions: 'Azioni',
        eventTypes: {
          manualInput: 'Inserimento Manuale',
          deviceSync: 'Sincronizzazione Dispositivo',
          uploaded: 'Caricato',
          coachingSession: 'Sessione di Coaching',
        },
        validation: {
          eventTypeRequired: 'Il tipo di evento è obbligatorio',
          dateTimeRequired: 'Data e ora sono obbligatorie',
          invalidDateTime: 'Data e ora non valide',
          atLeastOneMeasurement: 'Inserisci almeno un valore di misurazione',
          invalidValue: 'Valore non valido',
          validationFailed: 'Validazione fallita',
          fixErrors: 'Si prega di correggere tutti gli errori di validazione prima di inviare',
        },
        messages: {
          noChanges: 'Nessuna modifica da salvare',
          successSingle: 'Osservazione salvata con successo',
          successMultiple: 'Tutte le voci di osservazione inviate con successo!',
          submitError: 'Errore nell\'invio delle osservazioni',
          updateError: 'Errore nell\'aggiornamento dell\'osservazione',
          deleteSuccess: 'Osservazione eliminata con successo',
          removeSuccess: 'Osservazione rimossa',
          deleteError: 'Errore nell\'eliminazione dell\'osservazione',
          loadError: 'Errore nel caricamento delle osservazioni',
          networkError: 'Errore di rete',
          saveError: 'Errore nel salvataggio delle modifiche',
        },
        dialog: {
          deleteTitle: 'Elimina Osservazione',
          deleteMessage: 'Sei sicuro di voler eliminare questo evento di osservazione? Questa azione non può essere annullata.',
          cancel: 'Annulla',
          delete: 'Elimina',
        },
        dayView: {
          previousDay: 'Giorno precedente',
          nextDay: 'Giorno successivo',
          today: 'Oggi',
          noEntries: 'Nessuna osservazione registrata in questo giorno',
          edit: 'Modifica',
          save: 'Salva',
          dataTypeNumber: 'Numero',
          dataTypeText: 'Testo',
          dataTypeBoolean: 'Sì/no',
          noProgramme: 'Nessun programma',
          noValues: 'Nessun valore registrato',
          newMeasurementTitle: 'Nuova Misurazione',
          previewPending: 'Non ancora salvato',
          programme: 'Programma',
          selectProgramme: 'Seleziona un programma',
          measurement: 'Misurazione',
          selectMeasurement: 'Seleziona una misurazione',
          noMeasurementSelected: 'Seleziona una misurazione prima di inserire un valore',
          noProgrammeSelected: 'Seleziona un programma prima di selezionare una misurazione',
          value: 'Valore',
          viewLabel: 'Vista',
          viewDay: 'Giorno',
          viewWeek: 'Settimana',
          viewMonth: 'Mese',
          previousWeek: 'Settimana precedente',
          nextWeek: 'Settimana successiva',
          previousMonth: 'Mese precedente',
          nextMonth: 'Mese successivo',
          noEntriesRange: 'Nessuna osservazione registrata in questo periodo',
          legendTitle: 'Programmi',
          legendScheduledLabel: 'Misurazione programmata',
          legendNotInProgramme: 'Non in un programma',
          dueLabel: 'Da rilevare',
          doneLabel: 'Fatto',
          dueTooltip: '{{measurement}} — {{programme}}',
          recordDue: 'Rileva {{measurement}}',
          slotHint: 'Clicca su un orario libero del calendario per registrare qualcosa di nuovo',
          moreEvents: '+{{count}} altri',
        },
      },
      settings: {
        title: 'Impostazioni di lingua e regione',
        language: 'Lingua',
        region: 'Regione',
        systemOfMeasurement: 'Sistema di Misurazione',
        timezone: 'Fuso Orario',
        metricSystem: 'Sistema Metrico',
        imperialSystem: 'Sistema Imperiale',
        usCustomaryUnits: 'Unità Consuetudinarie Statunitensi',
        regionInfoTitle: 'Informazioni Regionali',
        regionInfoText: 'Scegli la tua regione per visualizzare numeri, date e orari nei formati locali (ad es., USA: 1,234.56, 03/07/2025, 5:30 PM; Germania: 1.234,56, 07.03.2025, 17:30).',
        regionInfo: 'Scegli la tua regione per visualizzare numeri, date e orari nei formati locali.',
        selectLanguage: 'Seleziona Lingua',
        selectRegion: 'Seleziona Regione',
        selectMeasurement: 'Seleziona Sistema di Misurazione',
        selectTimezone: 'Seleziona Fuso Orario',
        preview: 'Anteprima',
        formatExamples: 'Esempi di Formato',
        save: 'Salva',
        cancel: 'Annulla',
        saving: 'Salvataggio...',
        savedSuccessfully: 'Impostazioni salvate con successo!',
        saveSuccess: 'Impostazioni salvate con successo!',
        warningTitle: 'Conferma Modifiche',
        warningMessage: 'Queste modifiche avranno effetto immediatamente. I cambiamenti di lingua aggiorneranno l\'interfaccia immediatamente, mentre le impostazioni regionali e di misurazione si applicheranno a tutti i dati visualizzati.',
        confirmSave: 'Salva Modifiche',
        languageLabel: 'Lingua',
        regionLabel: 'Regione',
        measurementLabel: 'Misurazione',
        numberLabel: 'Numero',
        dateLabel: 'Data',
        timeLabel: 'Ora',
        weightLabel: 'Peso',
        heightLabel: 'Altezza',
        distanceLabel: 'Distanza',
        temperatureLabel: 'Temperatura',
        saveFailed: 'Impossibile salvare le impostazioni.',
        languageSaveFailed: 'Impossibile salvare la lingua scelta.',
      },
      actions: {
        add: 'Aggiungi',
        view: 'Visualizza',
        edit: 'Modifica',
        delete: 'Elimina',
        save: 'Salva',
        cancel: 'Annulla',
        close: 'Chiudi',
        open: 'Apri',
      },
  recordPage: {
    path: 'Percorso',
    general: 'Generale',
  },
  programmePage: {
    measurements: 'Misurazioni',
    dashboards: 'Dashboard',
    notFoundTitle: 'Questo programma non è stato trovato',
    notFoundBody: 'Potrebbe essere stato rimosso, oppure appartiene a un’altra organizzazione.',
    loadFailedTitle: 'Non è stato possibile leggere questo programma',
    loadFailed: 'Riprova tra un momento.',
  },
  programmeBoards: {
    loading: 'Caricamento della dashboard',
    panelTitle: 'La dashboard di questo programma',
    panelHint: 'Ogni membro di questo programma la trova sulla propria dashboard appena contiene un blocco. Ciò che salvi lo vedono subito.',
    name: 'Nome',
    nameHint: 'Se lasciato vuoto, prende il nome del programma.',
    unsaved: 'Non salvata',
    save: 'Salva',
    discard: 'Annulla le modifiche',
    saved: 'Salvata. I membri di questo programma la vedono ora.',
    saveFailed: 'Non è stato possibile salvare la dashboard. Riprova.',
    emptyTitle: 'Questa dashboard è ancora vuota',
    emptyBody: 'Scegli un blocco qui sopra. I membri vedono la dashboard appena ne contiene uno.',
    deniedTitle: 'Non puoi modificare la dashboard di questo programma',
    deniedBody: 'Serve il permesso di configurare questo programma.',
    loadFailedTitle: 'Non è stato possibile leggere la dashboard',
    retry: 'Riprova',
    galleryHint: 'Scegli un blocco per metterlo in fondo a questa dashboard. Ogni blocco mostra una misurazione di questo programma.',
    arrangeHint: 'Trascina un blocco dalla maniglia o tira l’angolo in basso a destra. Ogni membro vi vede i propri valori.',
    noMeasurements: 'Questo programma non registra ancora nessuna misurazione. Aggiungine prima una nella scheda Misurazioni.',
  },
  questionnairePage: {
    questions: 'Domande',
    submissions: 'Invii',
    notFoundTitle: 'Questo questionario non è stato trovato',
    notFoundBody: 'Potrebbe essere stato rimosso o appartenere a un’altra organizzazione.',
    loadFailedTitle: 'Impossibile leggere questo questionario',
    loadFailed: 'Riprova tra un momento.',
  },
  tenantPage: {
    administrators: 'Amministratori',
    notFoundTitle: 'Questo tenant non è stato trovato',
    notFoundBody: 'Potrebbe essere stato rimosso, oppure l’indirizzo è sbagliato.',
    loadFailedTitle: 'Non è stato possibile leggere questo tenant',
    loadFailed: 'Riprova tra un momento.',
    table: {
      name: 'Nome',
      email: 'Email',
    },
    addButton: 'Aggiungi amministratore',
    remove: 'Rimuovi',
    removeTitle: 'Rimuovi amministratore',
    removeMessage: '{{name}} non amministrerà più {{tenant}}. Il suo account e il legame con l’organizzazione restano.',
    removed: 'Amministratore rimosso',
    added: 'Amministratore aggiunto',
    add: {
      title: 'Aggiungi un amministratore a {{tenant}}',
      person: 'Persona',
      personRequired: 'Scegli una persona',
      nobody: 'Nessuno in questa organizzazione può essere scelto.',
      peopleFailed: 'Non è stato possibile leggere le persone di questa organizzazione.',
      save: 'Aggiungi',
      failed: 'Non è stato possibile aggiungere l’amministratore.',
    },
  },
  grid: {
    noRowsTitle: 'Ancora niente',
    noRowsNotice: 'Le righe appaiono appena c’è qualcosa da mostrare.',
    noResultsTitle: 'Nessun risultato',
    noResultsNotice: 'Prova una ricerca più breve, o azzera i filtri.',
    actions: 'Azioni',
    edit: 'Modifica',
    remove: 'Rimuovi',
    clearSearch: 'Cancella ricerca',
    cancel: 'Annulla',
    save: 'Salva',
    saving: 'Salvataggio…',
    actionFailed: 'Non ha funzionato. Non è stato modificato nulla.',
    loadFailedTitle: 'Impossibile leggere questo elenco',
    add: 'Aggiungi',
    filter: 'Filtra',
    searchAll: 'Cerca in tutte le colonne',
    sortByField: 'Ordina per: {{field}}',
    sortByFieldDirection: 'Ordina per: {{field}}, {{direction}}',
    filterWithCount: 'Filtra ({{count}})',
    newestFirst: 'Più recenti prima',
    noResultsFor: 'Nessun risultato per «{{query}}»',
    clearSearchAndFilters: 'Cancella ricerca e filtri',
    tryAgain: 'Riprova',
    rowsPerPage: 'Righe per pagina',
    range: '{{from}}–{{to}} di {{count}}',
    previousPage: 'Pagina precedente',
    nextPage: 'Pagina successiva',
  },
  coaches: {
    title: 'Coach',
    subtitle:
      'I coach che la tua organizzazione offre. Scegli tu chi chiedere e cosa ' +
      'può vedere delle tue misurazioni.',
    coachingSubtitle: 'Le persone che segui, le richieste che ti arrivano e come ti mostra l\'elenco dei coach.',
    unnamedCoach: 'Coach senza nome',
    unnamedMember: 'Membro senza nome',
    requestPendingChip: 'Richiesta inviata',
    ask: 'Chiedi a questo coach',
    details: 'Dettagli',
    withdrawRequest: 'Ritira la richiesta',
    access: {
      held: 'Vede {{see}} delle tue misurazioni e può registrarne {{record}}.',
      asked: 'Chiede di vedere {{see}} misurazioni e di registrarne {{record}}.',
    },
    cannotAsk: {
      alreadyMyCoach: 'Questo coach vede già le tue misurazioni.',
      requestPending: 'La tua richiesta attende ancora una risposta.',
      notAccepting: 'Questo coach al momento non accoglie nuove persone.',
    },
    askTitle: 'Chiedi a {{name}}',
    askExplainer:
      'Scegli cosa può vedere questo coach. Puoi cambiarlo, o terminarlo, in ' +
      'qualsiasi momento nella sezione dei tuoi coach.',
    measurement: 'Misurazione',
    maySee: 'Può vedere',
    mayRecord: 'Può registrare',
    maySeeAria: 'Può vedere {{name}}',
    mayRecordAria: 'Può registrare {{name}}',
    messageLabel: 'Messaggio (facoltativo)',
    sendRequest: 'Invia richiesta',
    askFailed: 'La richiesta non è stata inviata.',
    scopesUnavailable: 'Le misurazioni del tuo programma non sono leggibili.',
    noProgrammeYet:
      'Non segui ancora nessun programma, e ciò che puoi condividere viene dal programma.',
    someUnsharable:
      'Non ancora condivisibili: {{names}}. Queste misurazioni non hanno un codice LOINC: chiedi a un amministratore di assegnarne uno.',
    noMeasurementsYet:
      'Il tuo programma non nomina ancora misurazioni: non c\'è nulla da condividere.',
    waitingForYou: 'Attende la tua risposta',
    stillWaiting: 'Attende ancora una risposta',
    earlierRequests: 'Richieste precedenti',
    offeredAccess: 'Cosa ha chiesto',
    sharedProgrammes: 'Programmi che condividete',
    askedOn: 'Richiesto il {{when}}',
    answerableUntil: 'Si può rispondere fino al {{when}}',
    expiredOn: 'Scaduta il {{when}}',
    expired: 'Scaduta',
    accept: 'Accetta',
    decline: 'Rifiuta',
    declineTitle: 'Rifiuta la richiesta',
    declineReasonLabel: 'Motivo (facoltativo)',
    actionFailed: 'Non è andata a buon fine.',
    status: {
      pending: 'In attesa di risposta',
      accepted: 'Accettata',
      declined: 'Rifiutata',
      withdrawn: 'Ritirata',
      expired: 'Scaduta',
    },
    myListing: 'Il tuo profilo di coach',
    myListingExplainer:
      'Solo tu metti questo profilo nell\'elenco. È indipendente dalla tua ' +
      'preferenza di condivisione con la comunità.',
    listingSaved: 'Profilo di coach salvato.',
    saveFailed: 'Il profilo non è stato salvato.',
    headlineLabel: 'Descrizione breve',
    bioLabel: 'Su di te',
    programmesLabel: 'Programmi che accompagni',
    maxMembersLabel: 'Numero massimo di persone',
    maxMembersHelp_one: 'Adesso accompagni {{count}} persona.',
    maxMembersHelp_other: 'Adesso accompagni {{count}} persone.',
    acceptingLabel: 'Aperto a nuove persone',
    publishLabel: 'Proponi nella mia organizzazione',
    publishNeedsBoth:
      'Un profilo nell\'elenco ha bisogno di una descrizione breve e di ' +
      'qualcosa su di te: è su questo che si sceglie.',
    peopleYouFollow: 'Persone che accompagni',
    peopleYouFollowExplainer:
      'Cosa puoi vedere di qualcuno lo decide quella persona.',
    directoryUnknown: 'L\'elenco non è stato letto',
    directoryUnknownNotice: 'Riprova più tardi.',
    onlyYouListedTitle: 'Sei il solo coach nell’elenco',
    onlyYouListedNotice:
      'Nessun altro coach della tua organizzazione ha ancora pubblicato un profilo.',
    noneListedTitle: 'Ancora nessun coach nell\'elenco',
    noneListedNotice:
      'Appena un coach della tua organizzazione pubblica un profilo, apparirà qui.',
    canAsk: 'Coach a cui puoi chiedere',
    allAlreadyYoursTitle: 'Ancora nessun altro coach',
    allAlreadyYoursNotice: 'I coach che ti accompagnano già sono elencati qui sopra. Ogni altro coach della tua organizzazione comparirà qui appena pubblica un profilo.',
    onlyAccepting: 'Solo chi accoglie nuove persone',
    search: 'Cerca un coach',
    noneAcceptingTitle: 'Nessuno accoglie nuove persone',
    noneAcceptingNotice: 'Nessuno dei coach nell\'elenco è aperto a nuove persone in questo momento.',
    listingUnknownTitle: 'Non è stato possibile leggere il tuo profilo di coach',
    listingUnknown: 'Quello che vedi qui può essere superato.',
    noListingTitle: 'Non hai un profilo di coach',
    noListing:
      'In questa schermata un coach modifica il profilo che i membri vedono. Il tuo account non ha un ruolo di coach, quindi qui non c\'è ancora nulla da modificare.',
    grantsUnknownTitle: 'Non è stato possibile leggere i tuoi coach',
    grantsUnknown: 'Quello che vedi qui può essere superato.',
    noneMatchTitle: 'Nessun coach trovato',
    noneMatchNotice: 'Niente corrisponde a "{{query}}". Prova una parte di un nome o di un programma.',
    myCoaches: 'I tuoi coach',
    changeOnCoaches:
      'Cambia quali misurazioni un coach può vedere nella pagina dei coach.',
    whatTheyMaySee: 'Cosa può vedere',
    sinceExplainer:
      'Hai dato questo accesso il {{when}}. Le modifiche valgono subito.',
    saveAccess: 'Salva le modifiche',
    accessSaved: 'Modifiche salvate.',
    accessSaveFailed: 'La modifica non è stata salvata.',
    keepOneOrEnd:
      'Tieni almeno una misurazione, oppure termina invece l\'accesso: così il coach ne viene informato.',
    nothingShared: 'Con questo coach non è condiviso nulla.',
    accessEndedOn: 'Questo accesso è terminato il {{when}}.',
    offerUnreadable:
      'Le misurazioni del tuo programma non sono leggibili, quindi è elencato solo ciò che è già condiviso.',
    endCoaching: 'Termina accesso',
    endCoachingTitle: 'Termina accesso',
    endCoachingBody:
      '{{name}} non potrà più vedere le tue misurazioni. Quello che è già ' +
      'registrato resta.',
    grantedOn: 'Accesso dato il {{when}}',
    endedCoaching: 'Accompagnamento terminato',
    endedOn: 'Terminato il {{when}}',
    revokeFailed: 'L\'accesso non è stato terminato.',

    tabs: {
      coaches: 'I miei coach',
      history: 'Storico',
      listing: 'Il mio profilo da coach',
      requests: 'Richieste per me',
      members: 'Persone che seguo',
    },

    noProgrammeTitle: 'Non segui ancora nessun programma',
    noProgrammeNotice: 'Un coach segue un programma. Appena ne segui uno, qui compaiono i coach che lo seguono.',
    noHistoryTitle: 'Niente da rivedere per ora',
    noHistoryNotice: 'I percorsi conclusi e le richieste rimaste senza esito restano qui.',
    peopleYouCoached: 'Persone che hai seguito',
    noPastMembersTitle: 'Nessuno ha smesso',
    noPastMembersNotice: 'Tutte le persone che segui sono ancora con te. Il percorso che finisce resta registrato qui.',
    noOpenRequestsTitle: 'Nessuna richiesta in attesa',
    noOpenRequestsNotice: 'Quando qualcuno ti chiede di seguirlo, la richiesta compare qui.',
    answeredRequests: 'Richieste già risposte',
    noMembersYetTitle: 'Non segui ancora nessuno',
    noMembersYetNotice: 'Appena qualcuno accetta la tua richiesta, comparirà qui con ciò che ti lascia vedere.',
    memberUnreadableTitle: 'Non è stato possibile leggere queste misurazioni',
    memberUnreadable: 'Riprova tra un momento.',
    nothingPermittedTitle: 'Niente da mostrare',
    nothingPermittedNotice: 'I programmi di questa persona non includono misurazioni che possano esserti condivise.',
    nothingSharedWithYouTitle: 'Ancora niente condiviso',
    nothingSharedWithYouNotice: 'Questa persona non ti ha ancora condiviso alcuna misurazione. Qui sotto trovi ciò che potrebbe condividere.',
    notShared: 'Non condiviso con te',
    notSharedNotice: 'Questa persona non ha condiviso questa misurazione, quindi non viene mostrato nulla al riguardo.',
    sourceUnavailable: 'La fonte non ha risposto',
    sourceIncomplete: 'Parzialmente illeggibile',
    sourceIncompleteNotice: 'Alcuni valori inviati da questa fonte non sono leggibili, quindi qui non c è tutto.',
    sourceSilent: 'La fonte che conserva questi valori non ha risposto',
    sourceRefused: 'Fonte non leggibile per te',
    sourceNotReadForYou: 'La fonte che conserva questi valori non può essere letta per tuo conto',
    recordedHere: 'Registrato su questa piattaforma',
    fromSourceAsOf: 'Da {{source}}, consultata {{when}}',
    asOfUnknown: 'in un momento imprecisato',
    mixedSources: 'I valori provengono da {{places}} fonti diverse, quindi non viene mostrata alcuna variazione.',
    sourcesDegradedTitle: 'Alcuni valori potrebbero mancare',
    sourcesDegraded: 'Nessuna risposta da {{names}}. I valori conservati lì potrebbero mancare da questa schermata.',
    sourcesRefusedTitle: 'Alcuni valori non possono essere mostrati',
    sourcesRefused: '{{names}} non può essere letta per tuo conto, quindi i valori conservati lì non compaiono in questa schermata. Si tratta dell\'accesso tra quella fonte e questa piattaforma, non di ciò che questa persona ha condiviso con te.',
    sourceNotConnectedChip: 'Non connesso',
    sourceNotConnectedCaption: 'Collega il tuo account per leggere i valori conservati in questa fonte',
    sourcesNotConnectedTitle: 'Collega per leggere alcuni valori',
    sourceNotConnected: '{{name}} può essere letta solo con il tuo account. Collegala una volta e i valori che questa persona ha condiviso con te potranno essere mostrati qui.',
    sourceReconnect: 'Il tuo collegamento a {{name}} è terminato, quindi i valori conservati lì non compaiono in questa schermata. Collega di nuovo per leggere ciò che questa persona ha condiviso con te.',
    connectSource: 'Collega {{name}}',
    reconnectSource: 'Collega di nuovo {{name}}',
    connectedTitle: 'Collegato a {{source}}',
    connectedBody: 'Riapri questa persona per leggere i valori condivisi.',
    connectFailedTitle: 'Non è stato possibile creare il collegamento',
    connectFailedBody: 'Non è stato modificato nulla. Riprova più tardi.',
    notConnectedTitle: 'Non collegato a {{source}}',
    connectReasons: {
      refused: '{{source}} non ha accettato l\'accesso, quindi non è stato collegato nulla.',
      no_code: 'L\'accesso a {{source}} non ha restituito nulla, quindi non è stato collegato nulla.',
      no_party_id: 'Il tuo account presso {{source}} non ha ancora un ID JLAM e non può quindi nominarti lì. Chiedi a chi gestisce gli account.',
      no_person: 'Il tuo account qui non è collegato a nessuna persona, quindi non può essere collegato.',
    },
    sourcesStaleTitle: 'Alcuni valori potrebbero non essere aggiornati',
    sourcesStale: 'Nessun aggiornamento possibile da {{names}}. Quanto registrato lì dopo la verifica precedente manca da questa schermata.',
    withheldFromHistory: 'Non condiviso con te: {{names}}',
    source: 'Fonte',
    asOf: 'Consultata',
    here: 'Questa piattaforma',
    lastRecorded: 'Ultima registrazione il {{when}}',
    lastRecordedByYou: 'Ultima registrazione tua il {{when}}',
    noReadingYet: 'Nessun valore registrato',
    readOnlyHere: 'Sola consultazione',
    newValue: 'Nuovo valore',
    unit: 'Unità',
    measuredAt: 'Misurato il',
    momentInFuture: 'Una misurazione non può essere datata nel futuro.',
    recordedSome_one: '{{count}} valore registrato; il resto no.',
    recordedSome_other: '{{count}} valori registrati; il resto no.',
    record: 'Registra',
    recorded_one: '{{count}} valore registrato.',
    recorded_other: '{{count}} valori registrati.',
    recordFailed: 'Non è stato possibile registrare il valore.',
    nothingToRecord: 'Inserisci prima un valore.',
    valueNotANumber: 'Questa misurazione richiede un numero.',
    requestSent: 'Richiesta inviata a {{name}}.',
    requestAccepted: 'Ora segui {{name}}.',
    requestDeclined: 'Richiesta di {{name}} rifiutata.',
    requestWithdrawn: 'Richiesta a {{name}} ritirata.',
    accessEnded: '{{name}} non può più vedere le tue misurazioni.',
    findSomeoneYouCoach: 'Cerca una persona che segui',
    personColumn: 'Persona',
    sinceColumn: 'Dal',
    trendColumn: 'Andamento',
    lastActivityColumn: 'Ultima registrazione',
    lastActivityNever: 'Nulla registrato',
    lastActivityOn: 'Ultima registrazione il {{when}}',
    searchMembers: 'Cerca tra le persone che accompagni',
    noMatchesTitle: 'Nessuno corrisponde',
    noMatchesNotice: 'Prova una ricerca più breve, o svuota il campo.',
    openMember: 'Apri {{name}}',
    caseloadUnknownTitle: 'Non è stato possibile leggere le persone che accompagni',
    caseloadUnknownNotice: 'Riprova tra un momento.',
    jumpToAnother: 'Vai a un’altra persona',
    memberNotInCaseloadTitle: 'Non è una persona che accompagni',
    memberNotInCaseloadNotice: 'Questa persona non è nel tuo elenco. L’accompagnamento potrebbe essere terminato, o il link è vecchio.',
    trendNothing: 'Nulla condiviso',
    trendInRange_one: '{{count}} nell’intervallo',
    trendInRange_other: '{{count}} nell’intervallo',
    trendToward_one: '{{count}} si avvicina all’obiettivo',
    trendToward_other: '{{count}} si avvicinano all’obiettivo',
    trendAway_one: '{{count}} si allontana dall’obiettivo',
    trendAway_other: '{{count}} si allontanano dall’obiettivo',
    trendTracked_one: '{{count}} misurazione seguita',
    trendTracked_other: '{{count}} misurazioni seguite',
    coachingSince: 'Percorso dal {{when}}',
    viewTrends: 'Andamento',
    viewHistory: 'Cronologia',
    recordedAt: 'Registrato',
    value: 'Valore',
    recordedBy: 'Registrato da',
    you: 'Tu',
    noReadingsTitle: 'Ancora niente registrato',
    noReadingsNotice: 'I valori registrati per questa persona compaiono qui, dai più recenti.',
  },
  manageRoles: {
    noTenantNotice: 'I ruoli appartengono a un’organizzazione, e questo account non appartiene a nessuna.',
    noTenantTitle: 'Nessuna organizzazione di cui mostrare i ruoli',
  },
  look: {
    title: 'Simbolo e colori',
    symbol: {
      title: 'Simbolo',
      description: 'Mostrato a ogni membro accanto al nome del tenant nella barra di navigazione. Appartiene all’organizzazione, quindi tutti i suoi tenant mostrano lo stesso simbolo.',
      preview: 'Così appare il simbolo nella barra di navigazione',
      none: 'Nessun simbolo ancora. I membri vedono solo il nome del tenant.',
      accepted: 'PNG o WebP, al massimo 512 KB e almeno 64 × 64 pixel.',
      choose: 'Scegli un’immagine',
      save: 'Salva simbolo',
      saved: 'Simbolo salvato.',
      remove: 'Rimuovi simbolo',
      removed: 'Simbolo rimosso.',
      refused: 'Questo file non può essere usato. Scegli un’immagine PNG o WebP di al massimo 512 KB e almeno 64 × 64 pixel.',
      error: 'Non è stato possibile salvare il simbolo. Riprova.',
    },
    profiles: {
      title: 'Profili colore',
      description: 'I membri vedono il profilo predefinito finché non ne scelgono uno proprio. I profili standard di MLP sono sempre offerti accanto ai vostri.',
      standard: 'Profilo standard di MLP',
      own: 'Profilo di questo tenant',
      default: 'Predefinito',
      makeDefault: 'Rendi predefinito',
      defaultSaved: '{{name}} è ora il profilo predefinito.',
      edit: 'Modifica colori',
      history: 'Cronologia',
      add: 'Aggiungi un profilo',
      newName: 'Nome del profilo',
      create: 'Salva profilo',
      added: '{{name}} è stato aggiunto come versione 1.',
      duplicateName: 'Questo tenant ha già un profilo con questo nome. Scegli un altro nome.',
      loadError: 'Non è stato possibile caricare i profili colore. Ricarica la pagina per riprovare.',
      saveError: 'Non è stato possibile salvare la modifica. Riprova.',
    },
    editor: {
      title: 'Colori di {{name}}',
      newTitle: 'Nuovo profilo colore',
      hexLabel: 'Valore esadecimale di {{role}}',
      variants: 'Variante più chiara, principale e più scura, con il colore del testo sulla principale',
      textSample: 'Aa',
      contrastIntro: 'Con questi colori il testo sarebbe difficile da leggere. Cambia il colore indicato qui sotto:',
      contrastFailure: '{{role}}, {{pairing}}: {{ratio}}:1, dove serve almeno {{required}}:1',
      pairing: {
        textOnColour: 'testo su questo colore',
        linkOnPaper: 'come testo di un link su bianco',
        linkOnPage: 'come testo di un link sullo sfondo della pagina',
      },
      save: 'Salva come nuova versione',
      saved: 'Salvato come versione {{version}}.',
      reset: 'Torna a Meridian',
      close: 'Chiudi',
    },
    history: {
      title: 'Cronologia di {{name}}',
      version: 'Versione {{version}}',
      savedBy: '{{when}}, da {{who}}',
      savedAt: '{{when}}',
      current: 'In uso',
      rollBack: 'Torna a questa versione',
      rolledBack: 'Ripristinato. Salvato come versione {{version}}.',
      loadError: 'Non è stato possibile caricare la cronologia.',
      rollBackError: 'Non è stato possibile salvare il ripristino. Riprova.',
    },
    preview: {
      title: 'Anteprima',
      navigationCurrent: 'Dashboard',
      navigationOther: 'Misurazioni',
      button: 'Salva',
      secondButton: 'Aggiungi',
      link: 'Un link',
      chart: 'Una misurazione nell’arco di una settimana, con il suo intervallo obiettivo',
    },
    roles: {
      primary: {
        name: 'Colore principale',
        hint: 'Navigazione, pulsanti, link e focus',
      },
      secondary: {
        name: 'Secondo colore',
        hint: 'Pulsanti secondari ed evidenziazioni',
      },
      success: {
        name: 'Nell’intervallo',
        hint: 'Un valore dove deve essere, e ciò che è riuscito',
      },
      warning: {
        name: 'Fuori intervallo',
        hint: 'Un valore che si allontana dal suo obiettivo',
      },
      error: {
        name: 'Errore',
        hint: 'Errori, e ciò che richiede attenzione ora',
      },
      info: {
        name: 'Informazione',
        hint: 'Avvisi neutri',
      },
    },
    standard: {
      meridian: 'Meridian',
      lagune: 'Laguna',
      classic: 'Classico',
    },
    choice: {
      title: 'Profilo colore',
      description: 'Come ti appare l’app. La tua scelta vale appena salvi il profilo e ti segue sugli altri dispositivi.',
      followTenant: 'Predefinito di {{tenant}} ({{name}})',
      followMeridian: 'Predefinito di MLP (Meridian)',
      loadError: 'Non è stato possibile caricare i profili colore.',
    },
  },
  valueDetail: {
    title: 'Da dove arriva questo valore',
    traceTitle: 'Traccia di questo valore',
    loading: 'Lettura dell\'origine di questo valore',
    missing: 'Non c\'è nessun valore con questo numero.',
    failed: 'Non è stato possibile leggere l\'origine di questo valore.',
    retry: 'Riprova',
    value: 'Valore',
    time: 'Ora',
    notKnown: 'Di questo valore non si sa altro.',
    recorded: 'Come registrato',
    code: 'Codice',
    codeSystem: 'Sistema di codici: {{system}}',
    source: 'Fonte',
    sources: {
      manualInput: 'Inserito da te',
      deviceSync: 'Da una fonte collegata',
      uploaded: 'Da un documento',
      coachingSession: 'Da un coach',
    },
    shownAs: 'Mostrato come',
    converted: 'Come è stato convertito',
    noConversion: 'Nessuna conversione: mostrato come registrato.',
    conversion: {
      algebra: '1 {{from}} = {{factor}} {{to}}, confermato il {{date}}.',
      molarMass: '1 {{from}} = {{factor}} {{to}}, tramite la massa molare di {{analyte}} ({{mass}} g/mol, fonte: {{source}}), confermato il {{date}}.',
    },
    reference: 'Riferimento',
    changedSince: 'Cambiato da allora',
    notChanged: 'Il codice non è cambiato da allora.',
    laterRelease: 'Una versione successiva ha cambiato questo codice dopo la registrazione del valore.',
    change: '{{field}}: {{from}} → {{to}} ({{date}})',
    showFullOrigin: 'Mostra l\'origine completa',
    close: 'Chiudi',
    graphLabel: 'Letture. Usa i tasti freccia per spostarti tra di esse.',
    graphOpenHint: 'Premi Invio per aprirlo.',
  },
  groupingLevels: {
    label: 'Quanto ampiamente contano i valori',
    loading: 'Lettura dei livelli',
    loadFailed: 'Non è stato possibile leggere i livelli. Il livello salvato resta invariato.',
    THIS_CODE: {
      name: 'Solo questo codice',
      help: 'Contano solo i valori registrati con questo codice esatto.',
    },
    ANY_METHOD: {
      name: 'Lo stesso, qualunque sia il metodo',
      help: 'Contano i valori della stessa cosa, misurati a casa o in uno studio medico.',
    },
  },
    };

export default { translation };
